import type { Point } from "../canvas/canvasTypes";

export interface IntegerRect {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

export interface RasterSelection {
  readonly layerId: string;
  readonly sourceRect: IntegerRect;
  readonly clipRect: IntegerRect;
  readonly panelId?: string;
}

export interface RasterSelectionTransform {
  readonly centre: Point;
  readonly width: number;
  readonly height: number;
  readonly rotation: number;
  readonly flipX: boolean;
  readonly flipY: boolean;
}

export type RasterSelectionHandle =
  | "body"
  | "resize-north-west"
  | "resize-north-east"
  | "resize-south-east"
  | "resize-south-west"
  | "rotate";

export type RasterSelectionRotationHandleSide = "north" | "south";

export type RasterSelectionAction =
  "move" | "resize" | "rotate" | "flipHorizontal" | "flipVertical" | "duplicate" | "delete";

export interface RasterSelectionOverlayState {
  readonly selection: RasterSelection | null;
  readonly marquee: IntegerRect | null;
  readonly transform: RasterSelectionTransform | null;
  readonly transformActive: boolean;
  readonly rotationHandleSide: RasterSelectionRotationHandleSide | null;
}

export interface RasterSelectionUiState {
  readonly hasSelection: boolean;
  readonly isTransforming: boolean;
  readonly layerId: string | null;
  readonly bounds: IntegerRect | null;
}

export const EMPTY_RASTER_SELECTION_UI_STATE: Readonly<RasterSelectionUiState> = Object.freeze({
  hasSelection: false,
  isTransforming: false,
  layerId: null,
  bounds: null,
});
